import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-svgday',
  templateUrl: './svgday.component.html',
  styleUrls: ['./svgday.component.css']
})
export class SvgdayComponent implements OnInit {
  @Input() color: string;
  constructor() { }

  ngOnInit() {
  }

}
